import CompanySearchService from '@treasury/domain/backoffice/services/company/company-search-service';

export default class CompanySearchClient {
    async fetchCompanies() {
        return CompanySearchService.fetchCompanies();
    }
}
